<div id="am_pageLoader" class="animated fadeIn text-center am_loadingElement w-100 my-3 py-3">
	<i id="spinner" class="fa fa-spinner fa-spin fa-3x"></i>
</div>